import { IconPropsExtended } from './IconPropsExtended';

export default function AppRegistrationIcon({ size = 20, color = 'currentColor' }: IconPropsExtended) {
  if (size > 20) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 20 20" height={size} viewBox="0 0 20 20" width="20px" fill={color}>
        <g>
          <rect fill="none" height="20" width="20" />
        </g>
        <g>
          <g>
            <g>
              <rect height="3" width="3" x="8.5" y="4" />
            </g>
            <g>
              <rect height="3" width="3" x="4" y="13" />
            </g>
            <g>
              <rect height="3" width="3" x="4" y="8.5" />
            </g>
            <g>
              <rect height="3" width="3" x="4" y="4" />
            </g>
            <g>
              <rect height="3" width="3" x="13" y="4" />
            </g>
            <g>
              <polygon points="9,14.49 9,16 10.51,16 15.4,11.1 13.9,9.6" />
            </g>
            <g>
              <polygon points="11.5,9.88 11.5,8.5 8.5,8.5 8.5,11.5 9.87,11.5" />
            </g>
            <g>
              <path d="M16.85,8.94l-0.79-0.79c-0.2-0.2-0.51-0.2-0.71,0L14.6,8.9l1.5,1.5l0.75-0.75C17.05,9.45,17.05,9.13,16.85,8.94z" />
            </g>
          </g>
        </g>
      </svg>
    );
  } else {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 20 20" height={size} viewBox="0 0 20 20" width="20px" fill={color}>
        <g>
          <rect fill="none" height="20" width="20" />
        </g>
        <g>
          <g>
            <g>
              <rect height="3" width="3" x="8.5" y="4" />
            </g>
            <g>
              <rect height="3" width="3" x="4" y="13" />
            </g>
            <g>
              <rect height="3" width="3" x="4" y="8.5" />
            </g>
            <g>
              <rect height="3" width="3" x="4" y="4" />
            </g>
            <g>
              <rect height="3" width="3" x="13" y="4" />
            </g>
            <g>
              <polygon points="9,14.49 9,16 10.51,16 15.4,11.1 13.9,9.6" />
            </g>
            <g>
              <polygon points="11.5,9.88 11.5,8.5 8.5,8.5 8.5,11.5 9.87,11.5" />
            </g>
            <g>
              <path d="M16.85,8.94l-0.79-0.79c-0.2-0.2-0.51-0.2-0.71,0L14.6,8.9l1.5,1.5l0.75-0.75C17.05,9.45,17.05,9.13,16.85,8.94z" />
            </g>
          </g>
        </g>
      </svg>
    );
  }
}
